import { styled } from '@mui/system'
import { Button, Card, CardActions, CardContent, IconButton } from '@mui/material'

export const TileDeleteButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
}))

export const TileCard = styled(Card)(() => ({
  position: 'relative',
  minHeight: '20rem',
}))

export const TileCardContent = styled(CardContent)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  boxSizing: 'border-box',
  height: '80%',
}))

export const TileCardActions = styled(CardActions)(() => ({
  height: '20%',
  padding: '0',
}))

export const TileButton = styled(Button)(({ theme }) => ({
  flexGrow: '1',
  marginLeft: 'unset !important',
  borderTop: '1px solid rgba(0,0,0,0.05)',
  borderRadius: '0',
  width: '50%',
  height: '100%',
  background: theme.palette.primary.main,
  color: 'white',
  '&:hover': {
    background: theme.palette.primary.dark,
  },
  '&:first-of-type': {
    borderRight: '1px solid rgba(255,255,255,0.2)',
  },
}))
